module.exports = __webpack_public_path__ + "img/34.d70de8b6.jpg";